const state = () => ({
    eventname: ''
});

const mutations = {
    setName(state, eventname) {
        state.eventname = eventname
    }    
}

const getters = {
    eventname: (state) => state.eventname
}

const actions = {
    async setNameAction(context, eventname) {   
        context.commit('setName', eventname)
    }
}

export default {
    state, mutations, actions, getters
}